export enum CoHandlerErrorStatus {
  Unassigned = 1,
  InvalidUser = 2,
}
